"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotAuthenticatedError = void 0;
const ResponseError_1 = require("./ResponseError");
class NotAuthenticatedError extends ResponseError_1.ResponseError {
    constructor(message = "Not authenticated error.") {
        super("Not authenticated error.", message, 401);
    }
}
exports.NotAuthenticatedError = NotAuthenticatedError;
//# sourceMappingURL=NotAuthenticatedError.js.map